import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { chooseFileIcon } from "../../helpers/files/chooseFileIcon";

function FileIcon({
  extension,
  muted = false,
  className,
}: {
  extension: string;
  muted?: boolean;
  className?: string;
}) {
  const icon = chooseFileIcon(extension);

  return (
    <FontAwesomeIcon
      icon={icon}
      className={classNames(
        `fa-fw file-type file-type-${extension}`,
        className || "text-2xl",
        { muted: muted },
      )}
    />
  );
}

export default FileIcon;
